export const POSTHOG_EVENTS = {
  TEXT_RECAP: {
    BUTTON_SHOWN: 'text_recap_button_shown',
    BUTTON_CLICKED: 'text_recap_button_clicked',
    TEXT_CONVO_BUTTON_CLICKED: 'text_recap_text_convo_button_clicked',
  },
  TEXT_CONVO: {
    BUTTON_SHOWN: 'text_convo_button_shown',
    BUTTON_CLICKED: 'text_convo_button_clicked',
  },
} as const;

type NestedPostHogEvents = typeof POSTHOG_EVENTS;
type ExtractEventValues<T> =
  T extends Record<string, infer U>
    ? U extends string
      ? U
      : U extends Record<string, any>
        ? ExtractEventValues<U>
        : never
    : never;

export type PostHogEvent = ExtractEventValues<NestedPostHogEvents>;
